import React from 'react';
import { Typography } from '@mui/material';
import { MEASUREMENT_DATE_HEADER } from 'common/constants/documents';
import { gridLocalShortDate } from 'utilities';
import { MeasurementDateHeaderProps } from './MeasurementDateHeader.props';
import { useMeasurementDateHeaderStyles } from './MeasurementDateHeader.styles';
import { StyledDatePicker } from '../../../components/DatePickers';

const MeasurementDateHeader = ({ date }: MeasurementDateHeaderProps) => {
  const classes = useMeasurementDateHeaderStyles();

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <Typography
        variant="overline"
        gutterBottom
        style={{
          fontWeight: 400,
          fontSize: '0.625rem',
          color: '#8A9097',
        }}>
        {MEASUREMENT_DATE_HEADER}
      </Typography>
      <StyledDatePicker
        value={gridLocalShortDate(date) ? new Date(gridLocalShortDate(date)) : null}
        format="MM/dd/yyyy"
        disabled
        className={classes.date}
        onChange={() => {}}
      />
    </div>
  );
};

export default MeasurementDateHeader;
